import Event from '../../core/Event';
import EstimationPeriod from '../../../domain/EstimationPeriod';
import Estimations from '../../../domain/estimations/Estimations';

export default class EstimationsRequestSucceed extends Event {
    public static type = 'EstimationsRequestSucceed';

    constructor(
        public readonly estimationPeriod: EstimationPeriod,
        public readonly savedDraftEstimations: Estimations,
        public readonly placedEstimations: Estimations
    ) {
        super(EstimationsRequestSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsRequestSucceed.ts